import { render, staticRenderFns } from "./CarouselUpdates.vue?vue&type=template&id=f511a32e&scoped=true"
import script from "./CarouselUpdates.vue?vue&type=script&lang=js"
export * from "./CarouselUpdates.vue?vue&type=script&lang=js"
import style0 from "./CarouselUpdates.vue?vue&type=style&index=0&id=f511a32e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f511a32e",
  null
  
)

export default component.exports